export default __webpack_public_path__ + "static/media/03_hnevanq.f4074bce.webp";